import React, { useState } from "react";
import Header from "../../components/Header";
import AccoutSetting from "../../components/AccountSettings";

import { BsFileImageFill, BsFillPersonFill } from "react-icons/bs";

import { bgimg } from "../../constants/BackgroundColors";
import { HiOutlineLanguage } from "react-icons/hi2";
import { AiFillHome, AiOutlineClose } from "react-icons/ai";
import { TiTick } from "react-icons/ti";
import { CUSTOMIZATIONS } from "../../constants/settingsStrings.js";
import { Link } from "react-router-dom";
import Topbar from "../../components/Topbar";
import Bottombar from "../../components/Bottombar";

function DisplayCustomizationSecond() {
  const images = [...bgimg];
  console.log(images);
  const [bgImage, setBgImage] = useState(images[0].url);
  console.log(bgImage);

  const [ticked, setTicked] = useState(false);

  return (
    <div className="overflow-hidden dark:bg-black bg-white h-screen">
      <Topbar />
      <div className="md:block hidden">
        <Header />
      </div>
      <div className="sm:flex bg-white  dark:bg-black sm:items-center sm:space-x-10 sm:px-10 sm:mt-5 sm:justify-center">
        <div className="md:block hidden">
          <AccoutSetting active={CUSTOMIZATIONS} />
        </div>
        <div className=" mt-10 sm:shadow-lg z-auto w-[849px] h-[454px] rounded-[25px]">
          <h3 className=" grid place-content-center font-sans font-bold md:block hidden sm:ml-[300px] dark:text-white">
            Display and Customization{" "}
          </h3>

          <div className="flex sm:space-x-[120px]">
            <div>
              <div className="flex  space-x-14   sm:space-x-0">
                <Link to="/settings/customization">
                  <AiOutlineClose
                    size={24}
                    color="gray"
                    className="md:hidden ml-3 "
                  />
                </Link>
                <h3 className="font-semibold  place-items-center grid  text-[25px] sm:text-[20px]  sm:mb-0   mb-10 dark:text-white">
                  Background
                </h3>
              </div>

              <div className="grid grid-cols-2  gap-3 justify-center  mb-9 ">
                {bgimg.map(({ id, url, ticked }, i) => (
                  <div
                    key={id}
                    onClick={() => {
                      setBgImage(url);

                      images[i].ticked = !ticked;
                      images.forEach((n, index) => {
                        index === i
                          ? (ticked = true)
                          : (images[index].ticked = !images[i].ticked);
                      });
                    }}
                    className={` ${url} sm:w-[164px] sm:h-[100px] relative cursor-pointer   w-[164px] h-[133px] m-3 rounded-[25px]`}
                  >
                    <div
                      className={`  ${
                        images[i].ticked
                          ? "bg-[#119957] rounded-full w-3 h-3 m-3  items-center"
                          : " hidden"
                      } ]`}
                    >
                      <TiTick
                        className=" absolute"
                        color="white"
                        size={10}
                      ></TiTick>
                    </div>
                  </div>
                ))}
              </div>
              <button className="bg-[#0049F5] ml-4 rounded-[25px] sm:w-[247px] sm:hidden  w-[347px] shadow-lg mt-3 text-[20px] dark:text-white  text-white  h-[56px] sm:h-[34px]">
                {" "}
                Save
              </button>
            </div>
            <div className=" ">
              <h3 className="font-bold font-sans text-[15px] grid place-content-center md:block hidden  dark:text-white">
                Model Customization
              </h3>
              <div
                className={`  md:block hidden   items-center mr-4 relative bg-cover    w-full bg-center h-[398.83px]  rounded-[25px] grid place-content-center ${bgImage} `}
              >
                <img
                  src={require("../../assets/img/saly.png")}
                  alt=""
                  className="w-[185.04px] h-[397.59px]  ml-[78px]"
                />

                <div className="absolute w-full justify-between  p-3 flex fixed  bottom-0 mt-[100px] items-center left-0 ">
                  <BsFileImageFill color="white" className="cursor-pointer" />
                  <button className="text-white bg-[#6A6A6A] rounded-[25px] px-2 ">
                    save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Bottombar activeBar={'settings'}/>
    </div>
  );
}

export default DisplayCustomizationSecond;
